import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import api from '../utils/api';

const VerifyEmail = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('Verificando tu email...');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Falta el token de verificacion.');
      return;
    }
    api.get(`/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then((res) => {
        setStatus('success');
        setMessage(res.data?.message || 'Email verificado correctamente.');
      })
      .catch((error) => {
        setStatus('error');
        setMessage(error.response?.data?.detail || 'No se pudo verificar el email.');
      });
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary/10 via-background to-secondary/10">
      <div className="w-full max-w-md p-8">
        <Card className="shadow-lg border-border/50">
          <CardHeader className="text-center space-y-2">
            <CardTitle className="text-2xl font-heading">Verificacion de Email</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4 text-center">
            <p className={status === 'error' ? 'text-destructive' : 'text-muted-foreground'}>{message}</p>
            {status === 'success' && (
              <p className="text-sm text-muted-foreground">
                Tu cuenta ya esta activa. Puedes iniciar sesion y acceder al portal.
              </p>
            )}
            <div className="space-y-2">
              <Button onClick={() => navigate('/login')} className="w-full">
                Ir a login
              </Button>
              <Button variant="outline" onClick={() => navigate('/client/dashboard')} className="w-full">
                Ir al panel
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default VerifyEmail;
